import { CartProvider } from "./context/CartContext"; // Імпорт CartProvider
import AppRoutes from "./routes";
import CartModal from "./components/Cart/CartModal";
import CookieBanner from "./components/CookieBanner/CookieBanner";
import { CookieProvider } from "./context/CookieContext";
import GTMConsentHandler from "./components/GTMConsentHandler";
import { PopupProvider } from "./context/PopupContext";
import PopupMenu from "./components/PopupMenu/PopupMenu";
import { PopupFormProvider } from "./context/PopupFormContext";
import PopupForm from "./components/PopupForm/PopupForm";

const App = () => {
  return (
    <PopupProvider>
      <PopupFormProvider>
        <CookieProvider>
          {/* Додаємо CartProvider для надання доступу до кошика */}
          <CartProvider>
            <AppRoutes /> {/* Ваші маршрути */}
            <CartModal />
            <CookieBanner />
            <PopupMenu />
            <PopupForm />
            <GTMConsentHandler />
          </CartProvider>
        </CookieProvider>
      </PopupFormProvider>
    </PopupProvider>
  );
};

export default App;
